var _circle, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#008DE4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.95014 3H4.47679L4.27167 4.14275L6.50417 4.14539C7.60388 4.14539 7.9281 4.54391 7.91884 5.20369C7.91355 5.54151 7.76665 6.1142 7.70313 6.30026C7.53374 6.79511 7.1857 7.35857 5.88087 7.35725L3.71056 7.35593L3.5061 8.5H5.97417C6.84494 8.5 7.21415 8.39839 7.60719 8.21893C8.47664 7.81646 8.99407 6.96137 9.20184 5.84501C9.50952 4.18234 9.12574 3 6.95014 3Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.40915 5.17603C2.7607 5.17603 2.66807 5.59697 2.60719 5.85165C2.52647 6.18418 2.5 6.3201 2.5 6.3201H5.03291C5.68135 6.3201 5.77399 5.89915 5.83486 5.64448C5.91559 5.31194 5.94205 5.17603 5.94205 5.17603H3.40915Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDash);
export default __webpack_public_path__ + "static/media/DASH.cced9db1.svg";
export { ForwardRef as ReactComponent };